'use client';

import { __assign } from '../../_virtual/_tslib.js';
import React__default, { forwardRef, useRef, useImperativeHandle } from 'react';
import { useGlobalState } from '../context.js';
import validateOnSubmit from '../utils/validateOnSubmit.js';
import unproxify from '../utils/unproxify.js';

var HTMLForm = forwardRef(function (_a, ref) {
    var children = _a.children, requestScrollToFirstErrorElement = _a.requestScrollToFirstErrorElement;
    var globalState = useGlobalState();
    var formRef = useRef(null);
    useImperativeHandle(ref, function () { return ({
        dispatchEvent: function (event) {
            var _a;
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(event);
        },
        requestSubmit: function (submitter) {
            var _a;
            (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.requestSubmit(submitter);
        },
        requestGetCurrentValues: function () {
            var values = unproxify(globalState.values);
            globalState.getCurrentValues && globalState.getCurrentValues(values);
        }
    }); });
    var handleSubmit = function (e) {
        e.preventDefault();
        var containErrors = validateOnSubmit(globalState, requestScrollToFirstErrorElement);
        if (containErrors) {
            globalState.onSubmitError &&
                globalState.onSubmitError({
                    currentValues: unproxify(globalState.values),
                    errors: unproxify(globalState.errors)
                });
            return;
        }
        /**
         *   formState:state, error
         *
         */
        /*
         * Deep clone values
         * */
        var convertedFormValues = __assign(__assign({}, unproxify(globalState.values)), { initialSubmitValues: __assign({}, unproxify(globalState.initialSubmitValues || {})) });
        globalState.onSubmit(convertedFormValues);
    };
    return (React__default.createElement("form", { ref: formRef, onSubmit: handleSubmit }, children));
});

export { HTMLForm as default };
//# sourceMappingURL=HTMLForm.js.map
